"use client"

import { Copy } from "@/app/components/copy/copy"
import { useFormattedAddress } from "@/app/wallet-connect/hooks"
import { getRawAddress } from "@anaconda/core/blockchain/address"
import type { CollectionId } from "@anaconda/core/nft-collection/types"

export function CollectionAddress(props: { address: CollectionId }) {
  const address = getRawAddress(props.address)
  const formattedAddress = useFormattedAddress(address)

  return <Copy copyValue={address}>{formattedAddress}</Copy>
}
